var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPedalBike = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 50,
  fill: "none",
  viewBox: "0 0 50 50"
}, props), /*#__PURE__*/React.createElement("mask", {
  width: 50,
  height: 50,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h50v50H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#6C6C6C",
  d: "M10.417 40.625q-3.987 0-6.681-2.694T1.042 31.25q0-3.906 2.746-6.68 2.745-2.775 6.628-2.775 3.57 0 6.244 2.416t3.084 5.997h3.677l-4.47-12.5h-3.326v-2.083h8.333v2.083h-2.772l1.45 4.087H34.96l-3.502-9.615a1 1 0 0 0-.4-.541q-.28-.18-.642-.18h-4.375V9.374h4.375q.995 0 1.821.549.828.549 1.176 1.518l3.782 10.329h2.388q3.882 0 6.629 2.746t2.746 6.629q0 3.894-2.74 6.647-2.74 2.752-6.635 2.752-3.59 0-6.208-2.364t-3.119-5.89H19.744q-.409 3.595-3.122 5.964t-6.206 2.37m0-2.083q2.616 0 4.613-1.653t2.582-4.597h-6.154v-2.084h6.154q-.585-2.956-2.582-4.603-1.998-1.647-4.613-1.647-3.097 0-5.195 2.098-2.097 2.098-2.097 5.194 0 3.005 2.097 5.148 2.097 2.145 5.194 2.144m15.32-8.334h4.52q.18-1.439 1.063-3.38.883-1.945 2.574-2.95h-10.52zm13.846 8.334q3.097 0 5.194-2.144t2.098-5.148q0-3.097-2.098-5.194t-5.194-2.098q-.465 0-.865.02-.402.02-.785.14l2.163 5.762-1.955.737-2.06-5.761a7.13 7.13 0 0 0-2.796 2.764q-.993 1.76-.993 3.63 0 3.005 2.097 5.148 2.098 2.145 5.194 2.144"
}))));
export default SvgPedalBike;